module.exports = __webpack_public_path__ + "media/images/products/intro/2-9daf6ad814dd8c72aaa2bc1779c29ae1.svg";